export const ManuelTypeEnum = {
  BDR: 'bdr',
  UTILISATEUR: 'utilisateur',
} as const;

export type ManuelType = typeof ManuelTypeEnum[keyof typeof ManuelTypeEnum];
